// extracted by mini-css-extract-plugin
export var active = "_9x-a";
export var activeIndicator = "_9x-8";
export var animate = "_9x-9";
export var disabled = "_9x-b";
export var fullWidth = "_9x-2";
export var lg = "_9x-7";
export var md = "_9x-6";
export var redoButtonTabGroup = "_9x-0";
export var sm = "_9x-5";
export var tabButton = "_9x-3";
export var tabButtonsContainer = "_9x-1";
export var xs = "_9x-4";